<template>
  <section>
    <div class="modal-card">
      <header class="modal-card-head">
        <div class="modal-card-title">Listing Details</div>
      </header>
      <section class="modal-card-body">
        <section v-bind:style="{ display: displayStatus }">

          <div class="is-size-6">This listing is a marketing page for your rental. Use it on social media and rental sites so people can connect with you and fill out an application.</div>
          <section v-if="$store.state.listing.attributes.publicLink">
            <p>&nbsp;</p>
            <div class="is-size-6">Here's your link: </div>
            <div class="is-size-7">{{ $store.state.listing.attributes.publicLink }}</div>
          </section>

          <div class="is-divider" />

          <div class="level">
            <div class="level-left">
              <b-field
                class="field"
                label="Active?"
                custom-class="is-small has-text-weight-light"
              >
                <b-switch v-model="$store.state.listing.attributes.isActive">
                </b-switch>
              </b-field>
            </div>

            <div class="level-left">
              <b-field
                label="Available Date"
                custom-class="is-small has-text-weight-light"
              >
                <b-datepicker
                  icon="calendar-today"
                  v-model="$store.state.listing.attributes.availableDate"
                  position="is-bottom-left"
                ></b-datepicker>
              </b-field>
            </div>
          </div>

          <b-tabs
            v-model="activeTab"
            expanded
          >

            <b-tab-item label="1. Marketing">

              <b-field
                class="field"
                label="Title (e.g. Darling 3 Bedroom 2.5 Bath House next to Green Valley Park - $1,450)"
                custom-class="is-small has-text-weight-light"
              >
                <input
                  class="input"
                  v-model="$store.state.listing.attributes.title"
                  type="text"
                >
              </b-field>

              <b-field
                class="field"
                label="Description (e.g. Beautiful 3 bedroom 2.5 bath end unit, granite and tile, warm neutral color paint...)"
                custom-class="is-small has-text-weight-light"
              >
                <textarea
                  class="textarea"
                  v-model="$store.state.listing.attributes.description"
                ></textarea>
              </b-field>

              <b-field
                class="field"
                label="Features - (e.g. Washer/Dryer, Pool, Fitness Center, Central Air)"
                custom-class="is-small has-text-weight-light"
              >
                <b-taginput
                  maxlength="64"
                  placeholder="Add a feature"
                  icon="label"
                  :value="$store.state.listing.attributes.features"
                >
                </b-taginput>

              </b-field>

            </b-tab-item>

            <b-tab-item label="2. Property">

              <div class="columns">
                <div class="column is-12">
                  <b-field
                    class="field"
                    label="Street (e.g. 12345 Anystreet Dr)"
                    custom-class="is-small has-text-weight-light"
                  >
                    <input
                      class="input"
                      v-model="$store.state.listing.attributes.street"
                      type="text"
                    >
                  </b-field>
                </div>
              </div>

              <div class="columns">
                <div class="column is-4">
                  <b-field
                    class="field"
                    label="City (e.g. St. George)"
                    custom-class="is-small has-text-weight-light"
                  >
                    <input
                      class="input"
                      v-model="$store.state.listing.attributes.city"
                      type="text"
                    >
                  </b-field>
                </div>
                <div class="column is-4">
                  <b-field
                    class="field"
                    label="State (e.g. UT)"
                    custom-class="is-small has-text-weight-light"
                  >
                    <input
                      class="input"
                      v-model="$store.state.listing.attributes.state"
                      type="text"
                    >
                  </b-field>
                </div>
                <div class="column is-4">
                  <b-field
                    class="field"
                    label="Zip (e.g. 12345)"
                    custom-class="is-small has-text-weight-light"
                  >
                    <input
                      class="input"
                      v-model="$store.state.listing.attributes.zip"
                      type="text"
                    >
                  </b-field>
                </div>
              </div>

              <div class="columns">
                <div class="column is-4">
                  <b-field
                    class="field is-marginless"
                    label="Beds"
                    custom-class="is-small has-text-weight-light"
                  >
                    <input
                      class="input"
                      v-model="$store.state.listing.attributes.beds"
                      type="number"
                      min="1"
                      max="20"
                      maxlength="2"
                    >
                  </b-field>
                </div>
                <div class="column is-4">
                  <b-field
                    class="field"
                    label="Baths"
                    custom-class="is-small has-text-weight-light"
                  >
                    <input
                      class="input"
                      v-model="$store.state.listing.attributes.baths"
                      type="text"
                      min="1"
                      max="20"
                    >
                  </b-field>
                </div>
                <div class="column is-4">
                  <b-field
                    class="field"
                    label="Sqft"
                    custom-class="is-small has-text-weight-light"
                  >
                    <input
                      class="input"
                      v-model="$store.state.listing.attributes.sqft"
                      type="number"
                      min="1"
                      max="20000"
                    >
                  </b-field>
                </div>
              </div>

            </b-tab-item>

            <b-tab-item label="3. Policies">

              <b-field
                class="field"
                label="Rent Policy (e.g. $1,350 Monthly)"
                custom-class="is-small has-text-weight-light"
              >
                <input
                  class="input"
                  v-model="$store.state.listing.attributes.rentPolicy"
                  type="text"
                >
              </b-field>

              <b-field
                class="field"
                label="Deposit Policy (e.g. $800)"
                custom-class="is-small has-text-weight-light"
              >
                <input
                  class="input"
                  v-model="$store.state.listing.attributes.depositPolicy"
                  type="text"
                >
              </b-field>

              <b-field
                class="field"
                label="Application Policy (e.g. $35 application fee includes cost for screening service)"
                custom-class="is-small has-text-weight-light"
              >
                <input
                  class="input"
                  v-model="$store.state.listing.attributes.applicationPolicy"
                  type="text"
                >
              </b-field>

              <b-field
                class="field"
                label="Pet Policy (e.g. Small dogs & cats allowed, $250 deposit, $25 monthly for each)"
                custom-class="is-small has-text-weight-light"
              >
                <input
                  class="input"
                  v-model="$store.state.listing.attributes.petPolicy"
                  type="text"
                >
              </b-field>

            </b-tab-item>

            <b-tab-item label="4. Pictures">

              <b-field label="Add Pictures">
                <b-upload
                  v-model="dropFiles"
                  multiple
                  drag-drop
                >
                  <section class="section">
                    <div class="content has-text-centered">
                      <p>
                        <b-icon
                          icon="upload"
                          size="is-large"
                        >
                        </b-icon>
                      </p>
                      <p>Add pictures by dropping them here or click here to select</p>
                    </div>
                  </section>
                </b-upload>
              </b-field>

              <div class="tags">
                <span
                  v-for="(file, index) in dropFiles"
                  :key="index"
                  class="tag is-primary"
                >
                  {{file.name}}
                  <button
                    class="delete is-small"
                    type="button"
                    @click="deleteDropFile(index)"
                  >
                  </button>
                </span>
              </div>

              <b-field label="Remove Pictures">
                <div class="notification">
                  <div class="container is-fluid">
                    <div class="columns is-multiline">
                      <div
                        class="column is-one-third"
                        v-for="pictureUrl in $store.state.listing.attributes.pictureUrls"
                        :key="pictureUrl"
                      >
                        <figure class="image is-3by2">
                          <img v-bind:src="pictureUrl">
                        </figure>
                        <a
                          class="button is-small"
                          @click="removePicture(pictureUrl)"
                        >
                          <span class="icon is-small">
                            <i class="fas fa-trash"></i>
                          </span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </b-field>

            </b-tab-item>

          </b-tabs>

        </section>

        <span v-if="$store.state.isUploading">
          Uploading pictures...
          <progress
            class="progress is-success"
            max="100"
            :value.prop="$store.state.uploadPercentage"
          ></progress>
        </span>

      </section>

      <footer class="modal-card-foot">
        <button
          class="button"
          v-bind:disabled="$store.state.isUploading"
          type="button"
          @click="() => { cancelListing(); $parent.close() }"
        >Cancel</button>
        <button
          class="button is-primary"
          v-bind:disabled="$store.state.isUploading"
          @click="saveListing()"
        >Save</button>
      </footer>

    </div>
  </section>
</template>

<script>
import LiberatorService from "@/services/LiberatorService.js";
import Steps from "bulma-steps/dist/css/bulma-steps.min.css";
var axios = require("axios");

export default {
  components: {
    Steps
  },

  props: {
    propertyId: String,
    stage: String
  },

  computed: {
    displayStatus: function() {
      if (this.$store.state.isUploading) return "none";
      else return "inline";
    }
  },

  data() {
    return {
      note: "",
      activeTab: 0,
      dropFiles: [],
      originalListing: []
    };
  },

  methods: {
    removePicture(pictureUrl) {
      console.log("removePicture()", pictureUrl);
      this.$buefy.dialog.confirm({
        title: "Remove picture",
        message: `<b>Remove this picture?</b><br><br>This cannot be undone.`,
        confirmText: "Remove Picture",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          var propertyId = this.$store.state.property.id;
          var listingId = this.$store.state.listing.attributes.id;
          this.$store.dispatch("deletePictureFromListing", {
            propertyId,
            listingId,
            pictureUrl
          });
          this.$buefy.toast.open({
            message: "Picture removed",
            type: "is-success",
            duration: 3000
          });
        }
      });
    },

    deleteDropFile(index) {
      this.dropFiles.splice(index, 1);
    },

    async saveListing() {
      if (this.$store.state.listing.isNew) {
        var propertyId = this.$store.state.property.id;
        var listing = this.$store.state.listing.attributes;
        await this.$store.dispatch("newListing", { propertyId, listing });
      } else {
        propertyId = this.$store.state.property.id;
        listing = this.$store.state.listing.attributes;
        await this.$store.dispatch("editListing", { propertyId, listing });
      }
      await this.upload();
      this.$store.state.listing.isActive = false;
    },

    async cancelListing() {
      this.$store.state.listing.attributes = { ...this.originalListing };
    },

    async upload() {
      if (this.dropFiles.length == 0) return;

      this.$store.commit("SET_UPLOAD_STATUS", true);

      var i = 0;
      var totalSize = 0;
      for (i = 0; i < this.dropFiles.length; i++) {
        totalSize += this.dropFiles[i].size;
      }
      console.log("Total upload size=", totalSize);

      var s3Keys = [];
      var baseLoaded = 0;
      for (i = 0; i < this.dropFiles.length; i++) {
        var file = this.dropFiles[i];
        console.log("file", file);

        var result = await LiberatorService.getPresignedUrlForListings(
          this.$store.state.property.id,
          this.$store.state.listing.attributes.id,
          file.name,
          file.type
        );
        var presignedUrl = result.data.url;
        var s3Key = result.data.s3Key;

        console.log("result", result.data);

        var totalUploaded = 0;

        console.log("presignedUrl.length", presignedUrl.length);

        if (presignedUrl.length > 0) {
          var options = {
            onUploadProgress: progressEvent => {
              totalUploaded = progressEvent.loaded + baseLoaded;
              this.$store.state.uploadPercentage = parseInt(
                Math.round((totalUploaded / totalSize) * 100)
              );
              console.log("loaded, total", totalUploaded, totalSize);
            },
            headers: {
              "Content-Type": file.type
            }
          };
          console.log("options", options);

          await axios
            .put(presignedUrl, file, options)
            .then(response => {
              console.log("response", response);
              s3Keys.push(s3Key);
            })
            .catch(error => {
              console.log("error", error);
            });
        } else
          console.log(
            "presignedUrl.length less than zero",
            presignedUrl.length
          );

        baseLoaded += file.size;
      }

      var propertyId = this.$store.state.property.id;
      var listingId = this.$store.state.listing.attributes.id;
      await this.$store.dispatch("addPicturesToListing", {
        propertyId,
        listingId,
        s3Keys
      });

      this.$store.commit("SET_UPLOAD_STATUS", false);

      this.$store.state.uploadPercentage = 0;
    }
  },

  mounted() {
    this.originalListing = { ...this.$store.state.listing.attributes };
  }
};
</script>

<style>
@import "/bulma-steps/dist/css/bulma-steps.min.css";
</style>
